import { BottomSheet } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { RecruiterScreeningCallModalActions } from "./RecruiterScreeningCallModalActions";
import { RecruiterScreeningCallModalContent } from "./RecruiterScreeningCallModalContent";

export function RecruiterScreeningCallModal() {
  const bookingFlowState = useRecruiterBookingFlowContext();

  const onClose = () => {
    bookingFlowState.modalState.closeModal();
    bookingFlowState.reset();
    logEvent(APP_V2_APP_EVENTS.PLACEMENT_RECRUITER_SCREENING_CALL_MODAL_CLOSED, {
      path: bookingFlowState.path,
      stage: bookingFlowState.stage,
      showCallMeNow: bookingFlowState.screeningConfig.showCallMeNow,
    });
  };

  return (
    <BottomSheet
      canDismiss
      modalState={bookingFlowState.modalState}
      footer={
        <DialogFooter orientation="vertical">
          <RecruiterScreeningCallModalActions />
        </DialogFooter>
      }
      onClose={onClose}
    >
      <Stack direction="row" justifyContent="end" sx={{ paddingTop: 6, paddingRight: 6 }}>
        <IconButton iconType="close" variant="outlined" size="small" onClick={onClose} />
      </Stack>
      <Box sx={{ px: 8, py: 8 }}>
        <RecruiterScreeningCallModalContent />
      </Box>
    </BottomSheet>
  );
}
